import React from "react";


export type UiSegementedButtonType = {
    className?: string;
    key: string | number;
    label: string;
    _onClick?: () => void;
}

export const UiSegementedButton: React.FC<UiSegementedButtonType> = (props) => {

    return (
        <div
            key={props.key}
            className={(props.className ? `${props.className} `: "") + "flex justify-center items-center " +
                "h-9 min-w-24 w-full rounded-xl cursor-pointer"}
            onClick={props._onClick}
        >
            <p>{props.label}</p>
        </div>
    )
}
